import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';

export const EmployeeSupportOrServiceHeader = (): JSX.Element => (
  <p className={`ea-h3 ea-h3--thick ${dsClass.PADDING_BOTTOM_7}`}>{t.KNX3('Maintenance service request')}</p>
);
